import { RoundedButton } from "@greeter/matter";
import React, { useEffect, useState } from "react";

import css from "./WhiteRoundedButton.module.scss";

export type WhiteRoundedButtonProps = React.PropsWithChildren & {
  onClick: () => void;
};

export const WhiteRoundedButton: React.FC<WhiteRoundedButtonProps> = ({
  onClick,
  children,
}) => {
  return (
    <RoundedButton
      onClick={onClick}
      active={true}
      activeClassName={css.WhiteRoundedButton}
    >
      {children ? children : "Opret endnu en pakke"}
    </RoundedButton>
  );
};
